import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { sessionSedeType } from 'src/app/session/store/session.selectors';
import { map, withLatestFrom } from 'rxjs/operators';
import { XViaUpdated } from 'src/app/session/store/session.actions';


@Injectable()
export class SedeTypeInterceptor implements HttpInterceptor {

	private readonly XVIA_HEADER_RESPONSE: string = 'X-Via';

	constructor( private store: Store<AppState> ) {
	}

	intercept( req: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
		return next.handle( req ).pipe(
				withLatestFrom( this.store.select( sessionSedeType ) ),
				map( ([ response, sedeType ]) => {
					if( ( sedeType == null || sedeType.length == 0 ) && response instanceof HttpResponse ) {
						sedeType = response.headers.get( this.XVIA_HEADER_RESPONSE );
						if( sedeType && sedeType.length > 0 )
							this.store.dispatch( new XViaUpdated( { sedeType } ) );
					}
					return response;
				})
			);
	}

}